import { render, staticRenderFns } from "./qna.vue?vue&type=template&id=4a0a7217&scoped=true"
import script from "./qna.vue?vue&type=script&lang=js"
export * from "./qna.vue?vue&type=script&lang=js"
import style0 from "./qna.vue?vue&type=style&index=0&id=4a0a7217&prod&scoped=true&lang=css"
import style1 from "./qna.vue?vue&type=style&index=1&id=4a0a7217&prod&scoped=true&lang=css"
import style2 from "./qna.vue?vue&type=style&index=2&id=4a0a7217&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../makeup-web/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0a7217",
  null
  
)

export default component.exports